// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__24EJ9","savePackageButton":"ClientWallet_savePackageButton__1QjmI"};